import Vue                  from 'vue';
import BoxOverview          from './box-overview.vue';
import Mixins               from '../../mixins/mixin';

Vue.mixin(Mixins);

new Vue({
    el: '#js-box-overview',
    components: {
        'box-overview'      : BoxOverview
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/vue/components/boxes/box-overview.js